export var mainMixin = {
  computed: {},
  methods: {}
}
